import { Box, Avatar, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarDays,
  faCircleInfo
} from "@fortawesome/pro-regular-svg-icons";
import { semanticColors } from "../../utils/colors";
import { typography } from "../../utils/typography";
import moment from "moment";
import { useTranslation } from "react-i18next";

export function PlanMedicationNavbar({ patient }) {
  const { i18n } = useTranslation();
  const isPt = i18n.language.startsWith("pt");
  const locale = isPt ? "pt" : "en-gb";
  const rawDate = moment()
    .locale(locale)
    .format(isPt ? "dddd, D [de] MMMM" : "dddd, MMMM D");
  const dateStr = rawDate.charAt(0).toUpperCase() + rawDate.slice(1);
  const initials = patient?.name
    ? patient.name
        .split(" ")
        .filter(Boolean)
        .map(n => n[0].toUpperCase())
        .slice(0, 2)
        .join("")
    : "JS";

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        height: "82px",
        background: semanticColors.gradient.surface,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        px: { xs: "16px", sm: "24px" },
        zIndex: 1100
      }}
    >
      <img
        src="/logo_scribo.png"
        alt="Scribo"
        style={{ height: 40, width: "auto" }}
      />

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          bgcolor: "rgba(0,0,0,0.15)",
          borderRadius: "100px",
          px: "16px",
          py: "8px"
        }}
      >
        <FontAwesomeIcon icon={faCalendarDays} style={{ color: "white" }} />
        <Typography
          sx={{
            ...typography.body.lSemibold,
            color: "white"
          }}
        >
          {dateStr}
        </Typography>
      </Box>

      <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
        <FontAwesomeIcon
          icon={faCircleInfo}
          style={{ color: "white", fontSize: 22 }}
        />
        <Avatar
          sx={{
            width: 40,
            height: 40,
            bgcolor: "rgba(255,255,255,0.2)",
            ...typography.body.lSemibold,
            color: "white"
          }}
        >
          {initials}
        </Avatar>
      </Box>
    </Box>
  );
}
